import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import * as actions from 'modules/actions/account';
import _ from 'lodash';
import { Form, Modal, Input, Icon } from '@beehive/components';

import { showAlert } from 'utils';
import PropTypes from 'prop-types';
import commonMsg from 'messages';
import loginMsg from 'messages/Login';
import { encryptPassword } from 'utils/encryptPassword';
const messages = { ...commonMsg, ...loginMsg };

interface ResetPwdModalProps {
  modifyPwd: Function;
  onMenuVisibleChange: Function;
  visible: boolean;
  account: any;
}

const RESET_FORM_KEYS = {
  login: {
    type: 'text',
  },
  name: {
    type: 'text',
  },
  old_password: {
    type: 'input',
    required: true,
  },
  password: {
    type: 'input',
    required: true,
  },
  password_confirmation: {
    type: 'input',
    required: true,
  },
};
class ResetPwdModal extends React.Component<ResetPwdModalProps, any> {

  private fromRef: React.RefObject<typeof Form>;
  static contextTypes = {
    intl: PropTypes.object,
  };

  constructor(props: ResetPwdModalProps) {
    super(props);
    this.fromRef = React.createRef();
    this.state = {
      submitLoading: false,
      showError: false,
    };
  }
  handleModalSubmit = () => {
    const { intl } = this.context;
    const { modifyPwd } = this.props;
    if (this.fromRef.current) {
      if (!this.fromRef.current.valid()) {
        this.setState({showError: true});
      } else {
        const body = _.pick(this.state, Object.keys(RESET_FORM_KEYS).splice(2, 4));
        const newBody = {
          old_password: encryptPassword(body.old_password),
          password: encryptPassword(body.password),
          password_confirmation: encryptPassword(body.password_confirmation),
          encrypted: true,
        }
        this.setState({ submitLoading: true });
        modifyPwd(newBody).then((res: any) => {
          if (res?.data?.messages) {
            this.setState({
              submitLoading: false,
              showError: true,
              errorMsg: {...res.data.messages},
            });
          } else {
            showAlert({ type: 'success', message: intl.formatMessage(messages.modifySuccess) });
            this.handleHide();
          }
        }).catch(() => {
          this.setState({ submitLoading: false });
        });
      }
    }
  }

  // handleShow = (e?: React.MouseEvent) => {
  //   const { onMenuVisibleChange } = this.props;
  //   const { showModal } = this.state;
  //   e && e.stopPropagation();
  //   !showModal && onMenuVisibleChange(false);
  //   this.setState({showModal: true});
  // }

  handleHide = () => {
    this.setState({
      submitLoading: false,
      old_password: null,
      password: null,
      password_confirmation: null,
    });
    const { onMenuVisibleChange } = this.props;
    onMenuVisibleChange?.(false);
  }

  handleChange = (key: string, val: string) => {
    const { errorMsg } = this.state;
    const newErrorMsg = {...errorMsg};
    delete newErrorMsg[key];
    this.setState({ [key]: val, errorMsg: newErrorMsg });
  }
  handleShowType = (index: number, val: boolean) => {
    this.setState({ [`pwdType_${index}`]: val });
  }
  getFormItem = (key: string, index: number) => {
    const { account } = this.props;
    const type = RESET_FORM_KEYS[key].type;
    const disPlayType = this.state[`pwdType_${index}`];
    const val = _.get(this.state, `${key}`);
    switch (type) {
      case 'text': {
        return <span>{account[key]}</span>;
      }
      case 'input': {
        return (
          <Input
            value={val}
            suffix={
              <Icon
                size="small"
                name={disPlayType ? 'display-o' : 'hide-o'}
                onClick={() => this.handleShowType(index, !disPlayType)}
              />
            }
            type={disPlayType ? 'input' : 'password'}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleChange(key, e.target.value)}
          />
        );
      }
    }
  }

  public render() {
    const { intl } = this.context;
    const { submitLoading, showError, errorMsg } = this.state;
    const { visible } = this.props;
    return (
      <span onClick={(e) => e.stopPropagation()}>
        <Modal
          title={intl.formatMessage(messages.resetPwd)}
          width={600}
          onOk={this.handleModalSubmit}
          onCancel={this.handleHide}
          confirmLoading={submitLoading}
          visible={visible}
          className="mpc-modal-reset-password"
          destroyOnClose
          closable
          maskClosable={false}
        >
          <Form
            isLabelVertical={false}
            mode="edit"
            showError={showError}
            errorMsg={errorMsg}
            ref={this.fromRef}
          >
            {Object.keys(RESET_FORM_KEYS).map((key: string, index: number) => {
              return (
                <Form.Item
                  key={key}
                  itemKey={key}
                  required={RESET_FORM_KEYS[key].required}
                  label={intl.formatMessage(messages[key])}
                  itemColProps={{ span: 24 }}
                  itemLabelColProps={{ span: 4 }}
                  itemInputColProps={{ span: 20 }}
                  className=""
                  autoHeight
                >
                  {this.getFormItem(key, index)}
                </Form.Item>
              );
            })}
          </Form>
        </Modal>
      </span>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  const account = state.account;
  return { account };
};

const mapDispatchToProps = (dispatch: Dispatch<actions.AccountActions>) => {
  return bindActionCreators({
    modifyPwd: actions.modifyPwd,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPwdModal);
